import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { FORMAT_TEXT_COMMAND } from 'lexical'

export const Underline = ({ isUnderline, disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      tooltip="Underlined"
      size={size}
      icon="underlined-text"
      keyHint="Cmd+U"
      keyHintVisualOnly
      toggled={isUnderline}
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')
      }}
      disabled={disabled}
    />
  )
}
